module.exports = __webpack_public_path__ + "img/end_panda.e35a1b12.png";